export type OperationStatus =
  | "pending"
  | "running"
  | "completed"
  | "failed"
  | "cancelled";

// Mirrors the backend's TERMINAL_OPERATION_STATUSES: every poller stops on exactly these.
export const TERMINAL_OPERATION_STATUSES: readonly OperationStatus[] = [
  "completed",
  "failed",
  "cancelled",
];

export const isTerminalOperationStatus = (
  status: OperationStatus | undefined
): boolean =>
  status !== undefined && TERMINAL_OPERATION_STATUSES.includes(status);
